<template>
  <div
    ref="container"
    style="position: relative; height: 100%;"
    class="yxtbiz-polestar-radar"
  >
    <div
      :ref="`radarChart_${time}`"
      :style="{width: options.width, height: options.height}"
    />
    <yxt-popover
      v-model="isShow"
      popper-class="pop-wrap"
      :visible-arrow="false"
      trigger="hover"
      :max-width="800"
      :max-height="500"
      show-scroll
    >
      <div
        slot="reference"
        :style="{'position': 'absolute', 'left': offsetX+'px', 'top': offsetY+'px'}"
      />
      <sub-skills
        :id="subSkillsId"
        :sub-skills="subSkills"
        :label-data="labelData"
        :legend-fields="innerFields ? selectedFields : legendFields"
        :legend-map="legendMap"
        :value-map="valueMap"
        :source="source"
      />
    </yxt-popover>
    <div
      v-if="checkbox"
      class="chart-checkbox text-center"
      :style="checkboxStyle"
    >
      <component
        :is="frontendStyle ? 'yxtf-checkbox-group' : 'yxt-checkbox-group'"
        v-if="selectedFields && selectedFields.length"
        v-model="selectedFields"
        :min="1"
        @change="handleCheckedboxChange"
      >
        <template v-if="checkboxColorType === 'follow'">
          <component
            :is="frontendStyle ? 'yxtf-checkbox' : 'yxt-checkbox'"
            v-for="(field) in legendFields"
            v-show="legendMap[field].show"
            :key="field"
            :label="field"
            :disabled="legendMap[field].disabled"
            class="mr15"
            :style="'color:'+legendMap[field].color"
          >
            {{ legendMap[field].label }}
          </component>
        </template>
        <template v-else>
          <colorful-checkbox
            v-for="(field) in legendFields"
            v-show="legendMap[field].show"
            :key="field"
            :label="field"
            :disabled="legendMap[field].disabled"
            class="mr15"
            :color="legendMap[field].color"
          >
            {{ legendMap[field].label }}
          </colorful-checkbox>
        </template>
      </component>
      <div
        v-else-if="legendEmptyText"
        class="color-gray-7"
      >
        {{ legendEmptyText }}
      </div>
    </div>
  </div>
</template>
<script>
import { loadScript } from './util';
import ColorfulCheckbox from './components/colorfulCheckbox';
import subSkills from './components/subSkills';
const _EMPTY_DEFAULT = 'emptyDefault';
const _EMPTY_COLOR = '#ACB3CB';
function isIe10() {
  if (window.ActiveXObject) {
    let reg = /10\.0/;
    let str = navigator.userAgent;
    if (reg.test(str)) {
      return true;
    }
  }
  return false;
}

/**
 * 1.所有的能力id都跟着skillId玩，必须保证datas中每个数据都有skillId
 */

export default {
  name: 'YxtbizPolestarRadar',
  components: { subSkills, ColorfulCheckbox },
  props: {
    /**
     * 合并g2的chart配置
     */
    options: {
      type: Object,
      default: () => {
        return {
          padding: [30, 0, 100, 0]
        };
      }
    },
    datas: {
      type: Array,
      default: () => {
        return [];
      }
    },
    /**
     * 字段映射关系
     */
    fieldsMap: {
      type: Object,
      default: () => {
        return {};
      }
    },
    fields: {
      type: Array,
      default: () => {
        return [
          {
            id: 0,
            props: {
              hoverLevelProp: 'standardLevelName',
              hoverValueProp: 'combinedStdLevelStr'
            }, // hoverLevelProp 等级名称字段 hoverValueProp 得分原始值
            name: 'combStandardLevel', // 打点字段
            label: '标准', // 纬度名称
            color: '#7F8AB3', // 色值
            selected: true, // 默认是否打点
            disabled: false, // 能否取消选中
            show: true // 是否显示在多选框中
          }
        ];
      }
    },
    /**
     * 图例
     */
    legend: {
      type: Boolean,
      default: false
    },
    /**
     * same as fields
     */
    checkbox: {
      type: Boolean,
      default: true
    },
    /**
     * 边框
     */
    border: {
      type: Boolean,
      default: false
    },
    /**
     * 雷达图圆占比
     */
    radius: {
      type: Number,
      default: 0.8
    },
    /**
     * 坐标轴配置
     */
    axis: {
      type: Object,
      default: () => {
        return {
          labelLength: 8
        };
      }
    },
    /**
     * 标题配置
     */
    title: {
      type: Object,
      default: () => {
        return {
          show: false,
          text: '',
          option: {}
        };
      }
    },
    tooltip: {
      type: Object,
      default: () => {
        return {
          show: true
        };
      }
    },
    // 是否开启label文本的移入移出等事件，比较消耗性能，建议在h5关闭
    labelEvent: {
      type: Boolean,
      default: true
    },
    labelStyle: {
      type: Object,
      default: () => {}
    },
    // 二级分类中数据类型按fields字段显示
    innerFields: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    checkboxStyle: {
      type: Object,
      default: () => {}
    },
    // checkbox颜色: follow(文本类型颜色，checkbox默认颜色) marker（文本默认颜色，checkbox类型颜色）
    checkboxColorType: {
      type: String,
      default: 'follow'
    },
    // 标记是否是能力分类的字段名
    typeKey: {
      type: String,
      default: 'beanType'
    },
    // 标记二级能力数组的字段名
    childKey: {
      type: String,
      default: 'jqSkillMaps'
    },
    // 标记二级能力数组的字段名
    legendEmptyText: {
      type: String,
      default: ''
    },
    customAxis: {},
    // 虚线展示（hover无tooltip, 打最高点）用于无等级能力雷达图展示
    virtualLine: {
      type: Boolean,
      default: false
    },
    // tooltip value 映射方法
    valueMap: {
      type: Function,
      default: undefined
    },
    // 二级tooltip value 映射方法
    subValueMap: {
      type: Function,
      default: undefined
    },
    // 数据是否已经转换成10分制
    transformed: {
      type: Boolean,
      default: true
    },
    closeAnimate: {
      type: Boolean,
      default: false
    },
    frontendStyle: {
      type: Boolean,
      default: false
    },
    // 外部控制checkbox
    checkedFields: {
      type: Array
    },
    // 涉及测评多问卷连接空值
    connectNulls: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      time: new Date().getTime(),
      chart: null,
      mergeOptions: {},
      /**
     * 需要显示的范围(选中)
     */
      selectedFields: [],
      dv: null,
      defaultTitleOption: {
        position: ['0%', '0%'],
        top: true,
        style: {
          fill: '#666',
          fontSize: '18',
          fontWeight: 'bold'
        },
        offsetY: -20
      },
      tmphtml: '',
      isShow: false,
      subSkills: [], // 二级分类的数组
      subSkillsId: '', // 二级分类的id
      labelData: {},
      wrapClass: ['custom-wrap'],
      lheight: '',
      offsetX: 0,
      offsetY: 0
    };
  },
  computed: {
    /**
     * 需要显示的范围(所有)
     */
    legendFields() {
      return this.fields.map(item => item.name);
    },
    fieldsMapReverse() {
      let res = {};
      for (let key in this.fieldsMap) {
        res[this.fieldsMap[key]] = key;
      }
      return res;
    },
    legendMap() {
      let legendSet = {};
      this.fields.forEach(item => {
        legendSet[item.name] = {
          label: item.label,
          color: item.color,
          disabled: item.disabled,
          show: item.show
        };
      });
      return legendSet;
    },
    source() {
      return (this.legendMap && Object.keys(this.legendMap).length === 0) || this.virtualLine;
    }
  },
  watch: {
    datas: {
      deep: true,
      handler: function() {
        this.updateData();
      }
    },
    fields: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (!this.checkedFields && v) {
          this.selectedFields = v.filter(item => item.selected).map(item => item.name);
        }
      }
    },
    selectedFields: {
      deep: true,
      immediate: true,
      handler: function() {
        this.updateData();
      }
    },
    checkedFields: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (v) {
          this.selectedFields = v;
        }
      }
    },
    options: {
      deep: true,
      handler: function() {
        this.updateData();
      }
    }
  },
  mounted() {
    if (window.G2 && window.DataSet) {
      this.chartInited();
    } else {
      this.loadAllScript().then(() => {
        this.chartInited();
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  methods: {
    loadAllScript() {
      const loadG2 = loadScript(this.$imagesBaseUrl + 'npm/antv/g2/4.1.37/dist/g2.min.js', true);
      const loadDataSet = loadScript(this.$staticBaseUrl + 'ufd/c4d5f9/gwnl/pc/js/data-set-slim.js', true);
      return Promise.all([loadG2, loadDataSet]);
    },
    chartInited() {
      this.chart && this.chart.destroy();
      this.mergeOptions = {
        autoFit: true,
        container: this.$refs[`radarChart_${this.time}`],
        animate: true,
        ...this.options
      };
      this.chart = new window.G2.Chart(this.mergeOptions);
      // 自适应
      const e = document.createEvent('Event');
      e.initEvent('resize', true, true);
      window.dispatchEvent(e);
      this.chart.on('axis-label:click', (ev) => {
        this.labelClick(ev);
      });
      if (this.labelEvent) {
        this.setEvent();
      }
      this.initRadar();
    },
    setEvent() {
      // 4.0.15版本事件触发失效
      this.chart.on('axis-label:mouseleave', (ev) => {
        this.labelLeave(ev);
      });
      this.chart.on('axis-label:mouseenter', (ev) => {
        this.labelEnter(ev);
      });
    },
    initRadar() {
      this.dataHandler();
      this.chart.data(this.dv.rows, {
        fieldsLevel: {
          min: 0,
          max: 10
        },
        skillId: {
        }
      });

      this.chart.scale('fieldsLevel', {
        min: 0,
        max: 10,
        tickCount: 6
      });
      this.chart.coordinate('polar', {
        radius: this.radius
      });
      if (this.legendMap && Object.keys(this.legendMap).length === 1) {
        this.chart.tooltip({
          showTitle: false,
          showCrosshairs: false,
          shared: false,
          enterable: true,
          containerTpl: '<div class="g2-tooltip">' + '<p class="g2-tooltip-title" style="margin-top: 12px;margin-bottom: 4px;"></p>' + '<ul class="g2-tooltip-list"></ul>' + '</div>',
          itemTpl: `
              <li class="g2-tooltip-list_item color-gray-9" style="margin-bottom: 12px;list-style:none;">
              <span class="g2-tooltip-name max-width-126 ellipsis mr25">{name}:</span>
              <span style="float: right">{value}</span>
              </li>
            `,
          customItems: (items) => {
            return this.valueMap ? this.valueMap(items) : items;
          }
        });
      } else {
        this.chart.tooltip({
          showTitle: true,
          showCrosshairs: false,
          enterable: true,
          shared: true,
          domStyles: {
            'g2-tooltip': {
              boxShadow: '0px 0px 8px 0px #E7EAEE',
              paddingLeft: '16px',
              paddingRight: '16px'
            },
            'g2-tooltip-list-item': {
              marginTop: '4px',
              marginBottom: '0'
            },
            'g2-tooltip-title': {
              marginBottom: '0',
              maxWidth: '320px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              wordWrap: 'normal',
              wordBreak: 'normal',
              display: 'block'
            },
            'g2-tooltip-list': {
              marginBottom: '12px'
            }
          },
          customItems: (items) => {
            return this.valueMap ? this.valueMap(items) : items;
          }
        });
      }

      this.drawAxis();
      this.drawLegend();
      this.chart.point().position('skillId*fieldsLevel').color('fieldsType', (v) => {
        return (this.legendMap[v] && this.legendMap[v].color) || _EMPTY_COLOR;
      }).shape('circle').size(2).style({
        stroke: '#fff',
        lineWidth: 1,
        fillOpacity: 1
      }).tooltip(false);
      this.chart.line().position('skillId*fieldsLevel').color('fieldsType', (v) => {
        return (this.legendMap[v] && this.legendMap[v].color) || _EMPTY_COLOR;
      }).size(this.virtualLine ? 1 : 1.5).tooltip('name*fieldsType*fieldsLevel*originValue*skillId', (name, fieldsType, fieldsLevel, originValue, skillId) => {
        let rename;
        if (fieldsType === _EMPTY_DEFAULT) {
          rename = _EMPTY_DEFAULT;
        } else {
          rename = this.legendMap[fieldsType].label || name;
        }
        return {
          title: name,
          name: rename,
          fieldsType: fieldsType,
          value: this.levelFormat(originValue)
        };
      }).style({
        lineDash: this.virtualLine ? [4] : null
      });
      this.chart.area().position('skillId*fieldsLevel').color('fieldsType', (v) => {
        return (this.legendMap[v] && this.legendMap[v].color) || _EMPTY_COLOR;
      }).style({
        fillOpacity: 0.1
      }).tooltip(false);

      this.chart.filter('fieldsType', (v) => {
        if (this.selectedFields.indexOf(v) !== -1 || v === _EMPTY_DEFAULT) {
          return true;
        }
      });
      this.drawTitle();
      if (!this.tooltip.show || !this.legendFields.length || this.virtualLine) {
        this.chart.tooltip(false);
      }
      // ie10 中关闭动画，提高性能
      if (isIe10() || this.closeAnimate) {
        this.chart.animate(false);
      }

      this.chart.render();
    },
    drawAxis() {
      let axisOption = {
        line: {
          style: {
            lineWidth: 2,
            stroke: '#EEEFF3'
          }
        },
        tickLine: null,
        zIndex: 3,
        style: {
          lineHeight: 20
        },
        grid: {
          line: {
            // type: 'line',
            lineWidth: 1,
            style: {
              stroke: '#EBEDF3'
            }
          }
        },
        label: false
      };

      axisOption.label = {
        autoRotate: false,
        offset: (this.customAxis && this.customAxis.offset) || 12,
        formatter: (text) => {
          let label;
          let one = this.datas.filter(v => v.skillId === text);
          if (one.length > 0) {
            label = this.renameLabel(one[0], true);
          }
          return label;
        },
        style: this.labelStyle
      };

      this.chart.axis('skillId', axisOption);
      this.chart.axis('fieldsLevel', {
        line: null,
        tickLine: null,
        grid: {
          line: {
            type: 'circle', // line多边形， circle圆形
            style: {
              lineDash: null,
              lineWidth: 1,
              stroke: '#EEEFF3',
              strokeOpacity: 0.4
            }
          }
        },
        appendInfo: {
          id: 'skill'
        },
        label: false
      });
    },
    renameLabel(item, isSplit) {
      let name = item.name;
      if (!name) {
        return '';
      }
      let label = '';
      let isOversize = false;
      if (isSplit && name.length > this.axis.labelLength) {
        label = name.slice(0, this.axis.labelLength);
        isOversize = true;
      } else {
        label = name;
      }
      if (item[this.typeKey] && item[this.childKey]) {
        label += `(${item[this.childKey].length})`;
      }
      if (isOversize) {
        label += '...';
      }
      // 二级分类下能力的数量
      if (item.family === 1) {
        label += `(${item[this.childKey] && item[this.childKey].length})`;
      }
      return label;
    },
    drawLegend() {
      if (this.legend) {
        this.chart.legend('fieldsType', {
          itemName: {
            formatter: (v) => {
              return this.legendMap[v].label;
            }
          }
        });
      } else {
        this.chart.legend(false);
      }
    },
    drawTitle() {
      if (!this.title.show) {
        return;
      }
      this.defaultTitleOption.content = this.title.text;
      let option = { ...this.defaultTitleOption, ...this.title.option };
      this.chart.guide().text(option);
    },
    updateData() {
      if (!this.chart) {
        return;
      }
      this.chartInited();
      // this.chart.changeData(this.dv.rows)
      this.chart.filter('fieldsType', (v) => {
        if (this.selectedFields.indexOf(v) !== -1) {
          return true;
        }
      });
    },
    labelEnter(e) {
      let obj = e.target.get('delegateObject').item;
      let data = this.datas.filter(v => v.skillId === obj.id)[0];
      if (!data[this.childKey] || (data[this.childKey] && data[this.childKey].length === 0)) {
        return;
      }
      this.isShow = true;
      this.lheight = '';
      this.subSkills = data[this.childKey];
      this.subSkillsId = obj.id;
      this.labelData = data;
      this.offsetX = e.x;
      this.offsetY = e.y;
      this.$emit('labelEnter', e);
    },
    labelClick(e) {
      let obj = e.target.get('delegateObject').item;
      let data = this.datas.filter(v => v.skillId === obj.id);
      this.$emit('labelClick', e, data[0]);
    },
    labelLeave(e) {
      this.tmphtml = '';
      this.isShow = false;
    },
    labelChanged(e) {
      this.labelEnter(e);
      this.$emit('labelChanged', e);
    },
    // 将3级能力转化为雷达图中5级的显示
    transLevel(obj) {
      let max = this.transformed ? 10 : obj.maxLevel || 10;
      // virtualLine 空雷达图 显示虚线、打满的样式
      return this.virtualLine ? 10 : (obj.fieldsLevel / max) * 10;
    },
    // 原始数据处理
    dataHandler() {
      // eslint-disable-next-line no-undef
      this.dv = new DataSet.DataView().source(this.datas);
      // rename
      let map = { ...this.fieldsMap };
      this.dv.transform({
        type: 'rename',
        map: map
      });
      // 展开字段集
      this.dv.transform({
        type: 'fold',
        fields: this.legendFields.length ? this.legendFields : [_EMPTY_DEFAULT],
        key: 'fieldsType',
        value: 'fieldsLevel'
      });
      if (this.connectNulls) {
        this.dv.rows = this.dv.rows.filter(d => d.fieldsLevel !== null);
      }
      this.dv.transform({
        type: 'map',
        callback: (row) => {
          row.originValue = row.fieldsLevel;
          row.fieldsLevel = this.transLevel(row);
          row.fieldsLevel = typeof row.fieldsLevel === 'number' ? parseFloat(row.fieldsLevel.toFixed(2)) : row.fieldsLevel;
          row.originValue = typeof row.originValue === 'number' ? parseFloat(row.originValue.toFixed(2)) : row.originValue;
          if (!row.fieldsLevel && row.fieldsLevel !== 0 && row.fieldsLevel !== '0') {
            // null的时候补0
            row.fieldsLevel = 0;
          }
          // 处理下级能力的字段名
          if (row[this.typeKey] && row[this.childKey] && row[this.childKey].length > 0) {
            row[this.childKey] = row[this.childKey].map(bean => {
              for (let key in this.fieldsMapReverse) {
                bean[key] = bean[this.fieldsMapReverse[key]];
              }
              return bean;
            });
          }
          return row;
        }
      });
    },
    handleCheckedboxChange(o) {
      this.$emit('changeFields', o);
    },
    levelFormat(v) {
      if (typeof v === 'number' && v % 1 !== 0) {
        return v.toFixed(2);
      } else {
        return v;
      }
    }
  }
};
</script>
